// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner{display:inline-block;width:50px;height:50px;border:3px solid #d2e3ff;border-radius:50%;border-top-color:#013893;animation:spin 1s ease-in-out infinite;-webkit-animation:spin 1s ease-in-out infinite;-moz-animation:spin 1s ease-in-out infinite}.spinner.big{width:100px;height:100px}.spinner.small{width:25px;height:25px}@keyframes spin{to{transform:rotate(360deg)}}\n", ""]);
// Exports
module.exports = exports;
